import ApiService from "@/plugins/ApiService";
import { SET_LOADING, SET_PLAYLISTS } from "@/store/mutation-types";
import { FETCH_PLAYLISTS } from "@/store/action-types";


const state = {

    playlists: [],
    data: {},
}

const mutations = {
    [SET_PLAYLISTS](state, data) {

        state.playlists = data
    }



}


const actions = {

    [FETCH_PLAYLISTS]({ commit }, items) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.query('admin/playlists', items)
                .then(response => {
                    commit(SET_PLAYLISTS, response.data)
                    commit(SET_LOADING, false)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },





}

export default {
    state,
    mutations,
    actions
}